module.exports = __webpack_public_path__ + "static/media/beer-shop-now.c6de9d36.jpg";